module.exports = __webpack_public_path__ + "media/images/rema-4-5e7cd5d961132f4a7a2ac9eeb040422d.jpg";